export const ICON_LEFT_BUTTON = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="48"
      viewBox="0 0 16 48"
      fill="currentColor"
    >
      <path
        opacity="1"
        d="M12.5363 0H15.7336C11.1346 4.59901 8.55763 7.17598 3.95862 11.775V36.225C8.55763 40.824 11.1346 43.401 15.7336 48H12.5363C7.93733 43.401 5.36036 40.824 0.761353 36.225V11.775C5.36036 7.17598 7.93885 4.59749 12.5363 0Z"
        fill={`currentColor`}
      />
    </svg>
  )
}

export const ICON_RIGHT_BUTTON = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="48"
      viewBox="0 0 16 48"
      fill="currentColor"
    >
      <path
        opacity="1"
        d="M4.10572 0H0.908447C5.50746 4.59901 8.08442 7.17598 12.6834 11.775V36.225C8.08442 40.824 5.50746 43.401 0.908447 48H4.10572C8.70473 43.401 11.2817 40.824 15.8807 36.225V11.775C11.2817 7.17598 8.70321 4.59749 4.10572 0Z"
        fill={`currentColor`}
      />
    </svg>
  )
}

export const ICON_LEFT_BUTTON_SM = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="30"
      viewBox="0 0 10 30"
      fill="currentColor"
    >
      <path
        opacity="1"
        d="M7.26316 0H9.23533C6.39852 2.87438 4.80897 4.48499 1.97217 7.35937V22.6406C4.80897 25.515 6.39852 27.1256 9.23533 30H7.26316C4.42635 27.1256 2.83681 25.515 0 22.6406V7.35937C2.83681 4.48499 4.42729 2.87343 7.26316 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ICON_RIGHT_BUTTON_SM = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="30"
      viewBox="0 0 10 30"
      fill="currentColor"
    >
      <path
        opacity="1"
        d="M2.73682 0H0.764648C3.60145 2.87438 5.191 4.48499 8.02781 7.35937V22.6406C5.191 25.515 3.60145 27.1256 0.764648 30H2.73682C5.57362 27.1256 7.16317 25.515 9.99998 22.6406V7.35937C7.16317 4.48499 5.57269 2.87343 2.73682 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ICON_LEFT_BUTTON_SM_DELETE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="30"
      viewBox="0 0 12 30"
      fill="none"
    >
      <path
        d="M3.06017 7.35937C6.35087 4.48499 8.19475 2.87438 11.4854 0H9.19773C5.90703 2.87438 4.06316 4.48499 0.772461 7.35937V22.6406C4.06316 25.515 5.90703 27.1256 9.19773 30H11.4854C8.19475 27.1256 6.35087 25.515 3.06017 22.6406V7.35937Z"
        fill="#FF0000"
      />
    </svg>
  )
}

export const ICON_RIGHT_BUTTON_SM_DELETE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="30"
      viewBox="0 0 11 30"
      fill="none"
    >
      <path
        d="M2.48352 0H0.195801C3.4865 2.87438 5.33037 4.48499 8.62106 7.35937V22.6406C5.33037 25.515 3.4865 27.1256 0.195801 30H2.48352C5.77421 27.1256 7.61808 25.515 10.9088 22.6406V7.35937C7.61917 4.48499 5.77421 2.87343 2.48352 0Z"
        fill="#FF0000"
      />
    </svg>
  )
}

export const ICON_FILTER = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="currentColor"
    >
      <path
        d="M5 3.00001C4.73478 3.00001 4.48043 3.10537 4.29289 3.2929C4.10536 3.48044 4 3.73479 4 4.00001C4 4.26523 4.10536 4.51958 4.29289 4.70712C4.48043 4.89465 4.73478 5.00001 5 5.00001C5.26522 5.00001 5.51957 4.89465 5.70711 4.70712C5.89464 4.51958 6 4.26523 6 4.00001C6 3.73479 5.89464 3.48044 5.70711 3.2929C5.51957 3.10537 5.26522 3.00001 5 3.00001ZM2.17 3.00001C2.3766 2.41448 2.75974 1.90744 3.2666 1.5488C3.77346 1.19015 4.37909 0.997559 5 0.997559C5.62091 0.997559 6.22654 1.19015 6.7334 1.5488C7.24026 1.90744 7.6234 2.41448 7.83 3.00001H15C15.2652 3.00001 15.5196 3.10537 15.7071 3.2929C15.8946 3.48044 16 3.73479 16 4.00001C16 4.26523 15.8946 4.51958 15.7071 4.70712C15.5196 4.89465 15.2652 5.00001 15 5.00001H7.83C7.6234 5.58554 7.24026 6.09258 6.7334 6.45122C6.22654 6.80986 5.62091 7.00246 5 7.00246C4.37909 7.00246 3.77346 6.80986 3.2666 6.45122C2.75974 6.09258 2.3766 5.58554 2.17 5.00001H1C0.734784 5.00001 0.48043 4.89465 0.292893 4.70712C0.105357 4.51958 0 4.26523 0 4.00001C0 3.73479 0.105357 3.48044 0.292893 3.2929C0.48043 3.10537 0.734784 3.00001 1 3.00001H2.17ZM11 9.00001C10.7348 9.00001 10.4804 9.10537 10.2929 9.2929C10.1054 9.48044 10 9.73479 10 10C10 10.2652 10.1054 10.5196 10.2929 10.7071C10.4804 10.8947 10.7348 11 11 11C11.2652 11 11.5196 10.8947 11.7071 10.7071C11.8946 10.5196 12 10.2652 12 10C12 9.73479 11.8946 9.48044 11.7071 9.2929C11.5196 9.10537 11.2652 9.00001 11 9.00001ZM8.17 9.00001C8.3766 8.41448 8.75974 7.90744 9.2666 7.5488C9.77346 7.19015 10.3791 6.99756 11 6.99756C11.6209 6.99756 12.2265 7.19015 12.7334 7.5488C13.2403 7.90744 13.6234 8.41448 13.83 9.00001H15C15.2652 9.00001 15.5196 9.10537 15.7071 9.2929C15.8946 9.48044 16 9.73479 16 10C16 10.2652 15.8946 10.5196 15.7071 10.7071C15.5196 10.8947 15.2652 11 15 11H13.83C13.6234 11.5855 13.2403 12.0926 12.7334 12.4512C12.2265 12.8099 11.6209 13.0025 11 13.0025C10.3791 13.0025 9.77346 12.8099 9.2666 12.4512C8.75974 12.0926 8.3766 11.5855 8.17 11H1C0.734784 11 0.48043 10.8947 0.292893 10.7071C0.105357 10.5196 0 10.2652 0 10C0 9.73479 0.105357 9.48044 0.292893 9.2929C0.48043 9.10537 0.734784 9.00001 1 9.00001H8.17ZM5 15C4.73478 15 4.48043 15.1054 4.29289 15.2929C4.10536 15.4804 4 15.7348 4 16C4 16.2652 4.10536 16.5196 4.29289 16.7071C4.48043 16.8947 4.73478 17 5 17C5.26522 17 5.51957 16.8947 5.70711 16.7071C5.89464 16.5196 6 16.2652 6 16C6 15.7348 5.89464 15.4804 5.70711 15.2929C5.51957 15.1054 5.26522 15 5 15ZM2.17 15C2.3766 14.4145 2.75974 13.9074 3.2666 13.5488C3.77346 13.1902 4.37909 12.9976 5 12.9976C5.62091 12.9976 6.22654 13.1902 6.7334 13.5488C7.24026 13.9074 7.6234 14.4145 7.83 15H15C15.2652 15 15.5196 15.1054 15.7071 15.2929C15.8946 15.4804 16 15.7348 16 16C16 16.2652 15.8946 16.5196 15.7071 16.7071C15.5196 16.8947 15.2652 17 15 17H7.83C7.6234 17.5855 7.24026 18.0926 6.7334 18.4512C6.22654 18.8099 5.62091 19.0025 5 19.0025C4.37909 19.0025 3.77346 18.8099 3.2666 18.4512C2.75974 18.0926 2.3766 17.5855 2.17 17H1C0.734784 17 0.48043 16.8947 0.292893 16.7071C0.105357 16.5196 0 16.2652 0 16C0 15.7348 0.105357 15.4804 0.292893 15.2929C0.48043 15.1054 0.734784 15 1 15H2.17Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ICON_FILTER_UP_DOWN = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
    >
      <path
        d="M19.5 13L15.5 17M15.5 17L11.5 13M15.5 17V1M1.5 5L5.5 1M5.5 1L9.5 5M5.5 1V17"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ICON_TREE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="currentColor"
    >
      <rect width="6.33333" height="6.33333" fill="currentColor" />
      <rect x="10.667" width="6.33333" height="6.33333" fill="currentColor" />
      <rect
        x="5.33398"
        y="10.6665"
        width="6.33333"
        height="6.33333"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49902 4.00024H3.49902V8.83358H13.499V4.00024H14.499V9.83358H2.49902V4.00024Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12.4999V9.49988H9V12.4999H8Z"
        fill="currentColor"
      />
    </svg>
  )
}
